import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

interface PlanFeatureListProps {
  features: string[];
}

const PlanFeatureList: React.FC<PlanFeatureListProps> = ({ features }) => {
  return (
    <div className="flex flex-col gap-2 text-base font-medium text-storyblue">
      {features.map((feature, index) => (
        <div className="flex justify-start items-start gap-4" key={index}>
          <FontAwesomeIcon icon={faCheck} className=" text-2xl text-storylightgreen" />
          <h1>{feature}</h1>
        </div>
      ))}
    </div>
  );
};

export default PlanFeatureList;
